import React, { useState } from "react";
import { Box, createTheme, ThemeProvider } from "@mui/material";
import { useDelete, useGet } from "../../hooks/api-call";
import OrderListing from "./OrderListing";
import OrderSearchHeading from "./OrderSearchHeading"; // Make sure this is converted to MUI too
import OrderFilters from "./OrderFilters";
import OrderDrawer from "./drawer-forms/OrderDrawer";
import useCustomToast from "../../hooks/use-toast";
import { buildURLWithQueryParams } from "../../hooks/helper";

const theme = createTheme({
  palette: {
    mode: 'light',
    background: { default: '#fff' },
  },
});

const AdminOrderDashboard = () => {
  const [activePage, setActivePage] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedOrderForEdit, setSelectedOrderForEdit] = useState(false);

  const { isLoading, responseData, fetchData } = useGet(`orders/search`);
  
  const {
    responseData: orderStageCount,
    fetchData: fetchStageWiseQuantity,
  } = useGet(`orders/stageWiseQuantity`, [isDrawerOpen]);
  const { responseData: minerals } = useGet(`minerals`);

  const { deleteData } = useDelete();
  const { showSuccessToast } = useCustomToast();

  const fetchOrdersData = async (currentPage, details) => {
    const url = buildURLWithQueryParams("orders/search", {
      page: currentPage || activePage,
      size: pageSize,
      ...details,
    });
    await fetchData(url);

    const stageUrl = buildURLWithQueryParams("orders/stageWiseQuantity", {
      ...details,
    });
    await fetchStageWiseQuantity(stageUrl);
  };

  const handleRemoveOrder = (order) => {    
    deleteData(null, `orders/${order.orderId}`);
    showSuccessToast("Success", "Order deleted successfully");
    fetchOrdersData(activePage);
  };

  const handleEditOpen = (order) => {
    setIsDrawerOpen(true);
    setSelectedOrderForEdit(order);
  };

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ backgroundColor: "#f9fafb", minHeight: "100vh" }}>
        <Box sx={{ px: 5 }}>
          <OrderSearchHeading setIsDrawerOpen={setIsDrawerOpen} />
          <OrderFilters fetchOrdersData={fetchOrdersData} />
          <OrderListing
            handleCreateNewOrder={() => setIsDrawerOpen(true)}
            handleRemoveOrder={handleRemoveOrder}
            isLoading={isLoading}
            orders={responseData?.content}
            activePage={activePage}
            setActivePage={setActivePage}
            pageSize={pageSize}
            totalPages={Math.ceil(
              (responseData?.numberOfElements || 0) / pageSize
            )}
            fetchTrucksData={fetchOrdersData}
            handleEditOpen={handleEditOpen}
            orderStageCount={orderStageCount}
          />
        </Box>

        {isDrawerOpen && !!minerals && minerals.length > 0 && (
          <OrderDrawer
            setSelectedOrderForEdit={setSelectedOrderForEdit}
            selectedOrderForEdit={selectedOrderForEdit}
            fetchOrdersData={fetchOrdersData}
            setIsDrawerOpen={setIsDrawerOpen}
            minerals={minerals}
          />
        )}
      </Box>
    </ThemeProvider>
  );
};

export default AdminOrderDashboard;
